const COOKIE_KEY = 'CoreWalletAdminUi';
const API_BASE_PATH = '/api/v2';
const API_BASE_PATH_ADMIN = API_BASE_PATH + '/admin';
const AUTH_HEADER = 'Api-Key';
const API_DATE_TIME_FORMAT = 'YYYY-MM-DD[T]HH:mm:ss[Z]';
const DISPLAY_DATE_TIME_FORMAT = 'YYYY/MM/DD HH:mm:ss';
const JAVASCRIPT_DATE_FORMAT = 'YYYY-MM-DD';
const MAX_ROWS_PER_PAGE_OPTIONS = [5, 10, 25, 50];
const PER_PAGE = 50;
const REACT_ADMIN_RECORD_FORM = 'record-form';

export {
	PER_PAGE,
	API_BASE_PATH,
	API_BASE_PATH_ADMIN,
	AUTH_HEADER,
	API_DATE_TIME_FORMAT,
	DISPLAY_DATE_TIME_FORMAT,
	MAX_ROWS_PER_PAGE_OPTIONS,
	REACT_ADMIN_RECORD_FORM,
	JAVASCRIPT_DATE_FORMAT,
	COOKIE_KEY
};
